import { useEffect, useState } from "react";
import { zampassLogin } from "../services/api"; // should return the login URL from backend

function ZampassHandlerPage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const site = "public";
    const initiateLogin = async () => {
      try {
        // 1️⃣ Fetch the redirect URL from your API (server generates proper OAuth URL)
        const response = await zampassLogin(site);
        console.log("res", response);
        
        // Example expected response: { url: "https://zampass.com/oauth/authorize?..." }
        if (response.data.url) {
          window.location.href = response.data.url; // 2️⃣ Redirect user to ZamPass login
        } else {
          throw new Error("Invalid response from API");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to start login process. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    initiateLogin();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-4">
      {loading && <p className="text-gray-600 text-lg">Redirecting to ZamPass...</p>}

      {error && (
        <div className="bg-red-100 text-red-600 px-4 py-3 rounded-lg shadow-sm">
          <p>{error}</p>
          <button
            className="mt-3 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
}

export default ZampassHandlerPage;
